import type { CoreApiError } from '@lqa-frontend/api-services';
import type { AxiosError } from 'axios';
import React from 'react';
import {
	AlertMessage,
	AlertMessageDescription,
	AlertMessageTitle,
} from '@lqa-frontend/ui-system';

export function CoreApiErrorAlert({
	error,
	description,
}: CoreApiErrorAlertProps) {
	if (!error) return <></>;

	let generatedDescription: string;
	try {
		if (!error.response || !error.response.data.message) {
			generatedDescription = 'Error occured';
		} else if (typeof error.response.data.message === 'string') {
			generatedDescription = error.response.data.message;
		} else if (Array.isArray(error.response.data.message)) {
			generatedDescription = error.response.data.message
				.map((message) => {
					if (typeof message === 'string') {
						return message;
					}
					return `${message.property}: ${Object.values(message.constraints || {}).join(', ')}`;
				})
				.join(', ');
		} else {
			generatedDescription = JSON.stringify(error.response.data.message);
		}
	} catch (e: unknown) {
		generatedDescription = `Error occurred:${JSON.stringify(e)}`;
	}

	return (
		<AlertMessage variant="danger">
			<AlertMessageTitle>Error occurred</AlertMessageTitle>
			<AlertMessageDescription>
				{description?.[error.response?.status ?? 0] || generatedDescription}
			</AlertMessageDescription>
		</AlertMessage>
	);
}

interface CoreApiErrorAlertProps {
	error?: AxiosError<CoreApiError> | null;
	description?: Record<number, string> | null;
}
